(function(){
    'use strict';

    let stepOne = document.querySelectorAll('.iwt-animal-listing');

    if(stepOne.length) {
        document.cookie = "animalState=;animalCondition=";
    }
})();
